import { useIntl } from 'react-intl';
import { FC, useState } from 'react';
import { useAppSelector } from '../../utils/hooks';
import { ReactComponent as Logo } from '../../shared/icons/assets_login-logo.svg';
import CreateProfileForm from './CreateProfileForm';
import styles from './ManageInvitePage.module.scss';
import Modal from '../../components/Shared/Modal/Modal';

interface Props {
  email: string;
}

const CreateProfilePanel: FC<Props> = ({ email }) => {
  const intl = useIntl();

  const { eula } = useAppSelector((state) => state.eula);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModalHandler = () => setIsModalOpen(true);
  const closeModalHandler = () => setIsModalOpen(false);

  return (
    <>
      <div className={styles.formContainer}>
        <Logo />
        <CreateProfileForm email={email} onOpenModalClick={openModalHandler} />
      </div>
      <Modal
        header={intl.formatMessage({
          id: 'registerAccount.TermsAndConditions',
          defaultMessage: 'Terms and conditions',
        })}
        show={isModalOpen}
        onDismiss={closeModalHandler}
        dismissOnClick
      >
        {eula && <div dangerouslySetInnerHTML={eula.data} />}
      </Modal>
    </>
  );
};

export default CreateProfilePanel;
